import * as React from "react";
const SvgFiRrVolumeOff = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-volume-off_svg__a)">
      <path
        fill="#062147"
        d="M14.004 23.814a1 1 0 0 1-.181-.017c-2.999-.55-5.752-2.299-7.554-4.794H4.998c-2.757 0-5-2.243-5-5V9.998c0-2.757 2.243-5 5-5H6.27C8.068 2.505 10.821.758 13.822.204a1.003 1.003 0 0 1 1.181.984v21.627a1 1 0 0 1-1 1zM4.998 6.998c-1.654 0-3 1.346-3 3v4.005c0 1.654 1.346 3 3 3H6.78c.321 0 .622.154.811.414l.3.415a10.14 10.14 0 0 0 5.113 3.703V2.467A10.15 10.15 0 0 0 7.89 6.17l-.298.414a1 1 0 0 1-.812.415z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-volume-off_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolumeOff;
